import endpoints from './endpoints.js'
import httpClient from './httpClient'

// get order data
const getOrder = async (orderId) => {
  return await httpClient.get(endpoints.ORDERS.ORDER.replace(':orderId', orderId))
}

// add item to cart
const addItemToCart = async (orderId, payload) => {
  return await httpClient.post(endpoints.ORDERS.ADD_TO_CART.replace(':orderId', orderId), payload)
}

// remove item from cart
const removeItemFromCart = async (orderId, itemId) => {
  return await httpClient.delete(
    endpoints.ORDERS.REMOVE_FROM_CART.replace(':orderId', orderId).replace(':itemId', itemId)
  )
}

// change item quantity
const changeItemQuantity = async (orderId, payload) => {
  return await httpClient.post(endpoints.ORDERS.CHANGE_QUANTITY.replace(':orderId', orderId), payload)
}

// create order
const createOrder = async (payload) => {
  return await httpClient.post(endpoints.ORDERS.CREATE_ORDER, payload)
}

// update order
const updateOrder = async (payload) => {
  return await httpClient.post(endpoints.ORDERS.UPDATE_ORDER, payload)
}

// update order with PUT
const updateOrderWithPut = async (orderId, payload) => {
  return await httpClient.put(endpoints.ORDERS.UPDATE_ORDER_WITH_PUT.replace(':orderId', orderId), payload)
}

// add tip to order
const addTip = async (orderId, payload) => {
  return await httpClient.put(endpoints.ORDERS.ADD_TIP.replace(':orderId', orderId), payload)
}

// add order note
const addOrderNote = async (orderId, payload) => {
  return await httpClient.put(endpoints.ORDERS.ADD_ORDER_NOTE.replace(':orderId', orderId), payload)
}

// add checkin info
const addCheckinInfo = async (orderId, payload) => {
  return await httpClient.put(endpoints.ORDERS.ADD_CHECKIN_INFO.replace(':orderId', orderId), payload)
}

// check payment
const checkPayment = async (token, payload) => {
  return await httpClient.get(endpoints.ORDERS.CHECK_PAYMENT.replace(':token', token), {
    params: payload || undefined,
  })
}

// start payment
const startPayment = async (orderId, payload) => {
  return await httpClient.post(endpoints.ORDERS.PAYMENT.replace(':orderId', orderId), payload)
}

// get available discounts
const getAvailableDiscounts = async (orderId) => {
  return await httpClient.get(endpoints.ORDERS.AVAILABLE_DISCOUNTS.replace(':orderId', orderId))
}

// remove discount from order
const removeDiscount = async (orderId, payload) => {
  // Some tenant APIs don't parse JSON bodies on DELETE requests.
  // Send payload as both query params and body for maximum compatibility.
  return await httpClient.delete(endpoints.ORDERS.REMOVE_DISCOUNT.replace(':orderId', orderId), {
    params: payload || undefined,
    data: payload,
  })
}

// redeem promo code
const redeemPromoCode = async (orderId, payload) => {
  return await httpClient.post(endpoints.ORDERS.REDEEM_PROMO_CODE.replace(':orderId', orderId), payload)
}

// update item on cart
const updateItemOnCart = async (orderId, payload) => {
  return await httpClient.post(endpoints.ORDERS.UPDATE_ITEM.replace(':orderId', orderId), payload)
}

// google pay
const googlePay = async (orderId, payload) => {
  return await httpClient.post(endpoints.ORDERS.GOOGLE_PAY.replace(':orderId', orderId), payload)
}

// apple pay
const applePay = async (orderId, payload) => {
  return await httpClient.post(endpoints.ORDERS.APPLE_PAY.replace(':orderId', orderId), payload)
}

// apple pay session
const applePaySession = async (payload) => {
  return await httpClient.post(endpoints.ORDERS.APPLE_PAY_SESSION, payload)
}

export default {
  getOrder,
  addItemToCart,
  removeItemFromCart,
  changeItemQuantity,
  createOrder,
  updateOrder,
  updateOrderWithPut,
  addTip,
  addOrderNote,
  addCheckinInfo,
  checkPayment,
  startPayment,
  getAvailableDiscounts,
  removeDiscount,
  redeemPromoCode,
  updateItemOnCart,
  googlePay,
  applePay,
  applePaySession,
}
